import { MutationHookOptions, gql } from '@apollo/client';

import { edeApplicationQuery } from 'routes/marketplace-ede/queries/ede/getEdeApplication';
import { useEdeMutation, useEdeQueryName } from 'routes/marketplace-ede/context/edeQueryProvider';

const queryType = 'ADD_APPLICANT_AS_MEMBER';

const useAddApplicantAsMemberMutation = (options: MutationHookOptions = {}) => {
  const queryName = useEdeQueryName(queryType);

  const ADD_APPLICANT_AS_MEMBER = gql`
    mutation AddApplicantAsMember($appID: ID!, $productAppId: ID!, $applicantId: ID!, $payload: NewMemberInput!) {
      ${queryName} (
        appID: $appID
        productAppId: $productAppId
        applicantId: $applicantId
        payload: $payload
      ) {
        ${edeApplicationQuery}
      }
    }
  `;

  return useEdeMutation(ADD_APPLICANT_AS_MEMBER, options);
};

export default useAddApplicantAsMemberMutation;
